import React, { forwardRef } from "react";
import type { JSX, PropsWithChildren, HTMLAttributes, RefObject } from "react";

import cn from "classnames";
import { createPortal } from "react-dom";

import type { PropsWithTsId } from "../../../types/react";

export interface IPortal {
    getContainer: () => HTMLElement;
    portalClassName?: string;
    containerRef?: RefObject<HTMLDivElement>;
}

type PortalProps = PropsWithTsId<PropsWithChildren<IPortal>> &
    HTMLAttributes<HTMLDivElement>;

export const Portal = forwardRef<HTMLDivElement, PortalProps>(
    (
        {
            portalClassName,
            className,
            getContainer,
            children,
            "data-tsid": tsid,
            containerRef,
            ...props
        },
        ref,
    ): JSX.Element => {
        const rootClasses = cn(className, portalClassName);
        return createPortal(
            <div ref={ref}>
                <div
                    {...props}
                    className={rootClasses}
                    data-tsid={tsid}
                    ref={containerRef}
                >
                    {children}
                </div>
            </div>,
            getContainer(),
        );
    },
);

Portal.displayName = "Portal";
